import { useMakeStore } from '@/store/makes';

export const carsOptions = {
  getCarMakes: async (query: string | Record<string, any> = '') => {
    const store = useMakeStore();
    await store.fetchMakes(query);
    return store.makes;
  }
};
